var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/ComingSoon.png'),"description":"更多功能正在开发中"}}),_c('p',{staticClass:"index"},[_vm._v("敬 请 期 待...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }